import { render, staticRenderFns } from "./RegisterArrival.vue?vue&type=template&id=4a6cd8d6&scoped=true&"
import script from "./RegisterArrival.vue?vue&type=script&lang=js&"
export * from "./RegisterArrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6cd8d6",
  null
  
)

export default component.exports